import { formatInUtc, unixRangeForUtcDateLabel } from './utcDateHelper';

const HOUR_MS = 48 * 60 * 60 * 1000;
const DAY_MS = 90 * 24 * 60 * 60 * 1000;

export const resolveDynamicsGranularity = (fromUnix, toUnix) => {
  if (!fromUnix || !toUnix) return 'day';
  const durationMs = (toUnix - fromUnix) * 1000;
  if (durationMs <= HOUR_MS) return 'hour';
  if (durationMs <= DAY_MS) return 'day';
  return 'week';
};

export const formatPeriodRangeLabel = (fromUnix, toUnix) => {
  if (!fromUnix || !toUnix) return '';
  try {
    return `${formatInUtc(fromUnix, 'dd MMM yyyy')} – ${formatInUtc(
      toUnix,
      'dd MMM yyyy'
    )}`;
  } catch {
    return '';
  }
};

const parseBucketDate = (dateLabel, granularity = 'day') => {
  const range = unixRangeForUtcDateLabel(dateLabel, granularity);
  return range ? new Date(range.from * 1000) : null;
};

const isCurrentUtcBucket = (dateLabel, granularity) => {
  const parsed = parseBucketDate(dateLabel, granularity);
  if (!parsed) return false;

  const now = new Date();

  if (granularity === 'hour') {
    return (
      parsed.getUTCFullYear() === now.getUTCFullYear() &&
      parsed.getUTCMonth() === now.getUTCMonth() &&
      parsed.getUTCDate() === now.getUTCDate() &&
      parsed.getUTCHours() === now.getUTCHours()
    );
  }

  if (granularity === 'week') {
    const today = new Date(
      Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
    );
    const weekEnd = new Date(parsed.getTime() + 7 * 24 * 60 * 60 * 1000);
    return today >= parsed && today < weekEnd;
  }

  return (
    parsed.getUTCFullYear() === now.getUTCFullYear() &&
    parsed.getUTCMonth() === now.getUTCMonth() &&
    parsed.getUTCDate() === now.getUTCDate()
  );
};

export const formatDynamicsBucketLabel = (
  dateLabel,
  granularity,
  incompleteText
) => {
  if (!dateLabel) return '';

  let label = dateLabel;
  const parsed = parseBucketDate(dateLabel, granularity);
  if (parsed) {
    if (granularity === 'hour') {
      label = formatInUtc(parsed, 'dd MMM HH:mm');
    } else if (granularity === 'week') {
      label = formatInUtc(parsed, 'dd MMM yyyy');
    }
  }

  if (incompleteText && isCurrentUtcBucket(dateLabel, granularity)) {
    return `${label} (${incompleteText})`;
  }

  return label;
};
